import ReactLoading from "react-loading";
import { SecondaryButton } from "../SecondaryButton";
import { FooterContainer } from "./styles";

interface LoadMoreButtonProps {
  loading?: boolean;
  hasMore: boolean;
  onClick: () => void;
  label?: string;
}

export function LoadMoreButton({
  loading = false,
  hasMore,
  onClick,
  label = "Carregar mais",
}: LoadMoreButtonProps) {
  if (!loading && !hasMore) {
    return null;
  }

  return (
    <FooterContainer>
      {loading ? (
        <ReactLoading
          type={"bubbles"}
          color={"var(--fixit)"}
          height={64}
          width={64}
        />
      ) : (
        <SecondaryButton text={label} onClick={onClick} />
      )}
    </FooterContainer>
  );
}

export default LoadMoreButton;
